import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './App.css';

const App: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const heroImages = [
    {
      url: "https://readdy.ai/api/search-image?query=Luxury%20car%20being%20washed%20with%20steam%2C%20close-up%20shot%20with%20water%20droplets%20and%20steam%20visible%2C%20professional%20car%20washing%20service%2C%20high-end%20detailing%20process%2C%20dramatic%20lighting%20with%20blue%20tones%2C%20clean%20modern%20background%2C%20photorealistic&width=1920&height=1080&seq=1&orientation=landscape",
      title: "Premium Steam Cleaning For Your Precious Vehicle",
      subtitle: "Experience the ultimate car care with our advanced steam cleaning technology.",
    },
    {
      url: "https://readdy.ai/api/search-image?query=Professional%20detailing%20of%20luxury%20sports%20car%2C%20dramatic%20lighting%20highlighting%20the%20cars%20curves%2C%20steam%20and%20water%20droplets%20visible%2C%20premium%20garage%20setting%20with%20modern%20equipment%2C%20photorealistic%20high-end%20automotive%20scene&width=1920&height=1080&seq=8&orientation=landscape",
      title: "Professional Detailing Services",
      subtitle: "Restore your vehicle to showroom condition with our expert detailing.",
    },
    {
      url: "https://readdy.ai/api/search-image?query=Ceramic%20coating%20application%20on%20premium%20vehicle%2C%20technician%20applying%20protective%20coating%20in%20modern%20facility%2C%20dramatic%20lighting%20emphasizing%20the%20glossy%20finish%2C%20professional%20automotive%20care%20environment%2C%20luxury%20car%20maintenance&width=1920&height=1080&seq=9&orientation=landscape",
      title: "Advanced Protection Solutions",
      subtitle: "Protect your investment with our ceramic and graphene coating services.",
    },
    {
      url: "https://readdy.ai/api/search-image?query=Luxury%20car%20being%20washed%20with%20steam%2C%20close-up%20shot%20with%20water%20droplets%20and%20steam%20visible%2C%20professional%20car%20washing%20service%2C%20high-end%20detailing%20process%2C%20dramatic%20lighting%20with%20blue%20tones%2C%20clean%20modern%20background%2C%20photorealistic&width=1920&height=1080&seq=1&orientation=landscape",
      title: "Premium Steam Cleaning For Your Precious Vehicle",
      subtitle: "Experience the ultimate car care with our advanced steam cleaning technology.",
    },
    {
      url: "https://readdy.ai/api/search-image?query=Professional%20detailing%20of%20luxury%20sports%20car%2C%20dramatic%20lighting%20highlighting%20the%20cars%20curves%2C%20steam%20and%20water%20droplets%20visible%2C%20premium%20garage%20setting%20with%20modern%20equipment%2C%20photorealistic%20high-end%20automotive%20scene&width=1920&height=1080&seq=8&orientation=landscape",
      title: "Professional Detailing Services",
      subtitle: "Restore your vehicle to showroom condition with our expert detailing.",
    },
    {
      url: "https://readdy.ai/api/search-image?query=Ceramic%20coating%20application%20on%20premium%20vehicle%2C%20technician%20applying%20protective%20coating%20in%20modern%20facility%2C%20dramatic%20lighting%20emphasizing%20the%20glossy%20finish%2C%20professional%20automotive%20care%20environment%2C%20luxury%20car%20maintenance&width=1920&height=1080&seq=9&orientation=landscape",
      title: "Advanced Protection Solutions",
      subtitle: "Protect your investment with our ceramic and graphene coating services.",
    }


  ];

  const servicesList = "Steam Car Wash • Detailing Services • Ceramic Coating • Graphene Coating • Car Accessories • Custom Packages • Leather Treatment • Paint Correction • Wheel Protection • Headlight Restoration • Engine Bay Detailing";

  const services = [
    {
      image: "https://readdy.ai/api/search-image?query=Professional%20steam%20car%20wash%20in%20action%2C%20close-up%20of%20steam%20cleaning%20a%20luxury%20vehicle%2C%20water%20vapor%20visible%2C%20high-pressure%20cleaning%20equipment%2C%20clean%20modern%20garage%20setting%2C%20soft%20lighting%2C%20photorealistic%20detail%2C%20high-end%20car%20care%20service&width=600&height=400&seq=2&orientation=landscape",
      icon: "fa-cloud",
      title: "Steam Car Wash",
      description: "Eco-friendly deep cleaning that sanitizes and restores your vehicle's shine without harsh chemicals."
    },
    {
      image: "https://readdy.ai/api/search-image?query=Professional%20car%20detailing%2C%20close-up%20of%20hand%20polishing%20luxury%20car%20surface%2C%20microfiber%20cloth%2C%20premium%20detailing%20products%20visible%2C%20showroom%20environment%20with%20soft%20lighting%2C%20attention%20to%20detail%2C%20high-end%20car%20care%20service%2C%20photorealistic&width=600&height=400&seq=3&orientation=landscape",
      icon: "fa-spray-can",
      title: "Detailing Services",
      description: "Meticulous interior and exterior detailing that restores your vehicle to showroom condition."
    }
  ];

  const handleWhatsAppClick = (service: string = "") => {
    const phoneNumber = "+917386778999";
    const message = service
      ? `I'm interested in your ${service} service.`
      : "I would like to book a service.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="min-h-screen font-sans overflow-x-hidden">
      {/* Header */}
      <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? "bg-white shadow-md" : "bg-transparent"}`}>
        <div className="w-full px-4 py-3 flex justify-between items-center">
          <div className="flex items-center">
            <div className="text-3xl font-bold text-blue-600 flex items-center">
              <i className="fas fa-car-wash mr-2"></i>
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">
                SHINE WITH STEAM®
              </span>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            {/* <a href="#services" className="text-gray-800 hover:text-blue-600 transition-colors">Services</a>
            <a href="#pricing" className="text-gray-800 hover:text-blue-600 transition-colors">Pricing</a>
            <a href="#process" className="text-gray-800 hover:text-blue-600 transition-colors">Process</a>
            <a href="#accessories" className="text-gray-800 hover:text-blue-600 transition-colors">Accessories</a>
            <a href="#contact" className="text-gray-800 hover:text-blue-600 transition-colors">Contact</a> */}
            <button
              onClick={() => handleWhatsAppClick()}
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-lg flex items-center transition-all transform hover:scale-105"
            >
              <i className="fab fa-whatsapp mr-2 text-xl"></i>
              Book Now
            </button>
          </nav>

          <button
            className="md:hidden text-gray-800 focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"} text-2xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-white shadow-lg py-4 px-4 absolute w-full">
            <div className="flex flex-col space-y-4">
              <a href="#services" className="text-gray-800 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)}>Services</a>
              <a href="#pricing" className="text-gray-800 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)}>Pricing</a>
              <a href="#process" className="text-gray-800 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)}>Process</a>
              <a href="#accessories" className="text-gray-800 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)}>Accessories</a>
              <a href="#contact" className="text-gray-800 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)}>Contact</a>
              <button
                onClick={() => {
                  handleWhatsAppClick();
                  setIsMenuOpen(false);
                }}
                className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg flex items-center justify-center transition-all"
              >
                <i className="fab fa-whatsapp mr-2 text-xl"></i>
                Book Now
              </button>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="relative h-screen overflow-hidden">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          className="h-full w-full"
        >
          {heroImages.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="relative h-full w-full">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-transparent z-10"></div>
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{
                    backgroundImage: `url('${slide.url}')`,
                    backgroundAttachment: isMobile ? 'scroll' : 'fixed',
                    zIndex: -1
                  }}
                ></div>
                <div className="w-full px-4 h-full flex flex-col justify-center relative z-20">
                  <div className="max-w-2xl">
                    <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight text-white">{slide.title}</h1>
                    <p className="text-xl mb-8 text-gray-100">{slide.subtitle}</p>
                    <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 mb-8">
                      <button
                        onClick={() => handleWhatsAppClick()}
                        className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg flex items-center justify-center transition-all transform hover:scale-105 text-lg"
                      >
                        <i className="fab fa-whatsapp mr-2 text-xl"></i>
                        Book via WhatsApp
                      </button>
                      <a
                        href="#services"
                        className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg flex items-center justify-center transition-all hover:bg-white hover:text-blue-900 text-lg"
                      >
                        Explore Services
                        <i className="fas fa-arrow-right ml-2"></i>
                      </a>
                    </div>

                    {/* Auto Scrolling Services Text - Moved here */}
                    <div className="absolute left-0 right-0 bottom-24 mx-auto w-full">
                      <div className="bg-blue-600/80 py-3 overflow-hidden">
                        <div className="whitespace-nowrap animate-marquee text-white text-lg font-medium">
                          {[...Array(3)].map((_, i) => (
                            <span key={i} className="inline-block mx-8">
                              {servicesList}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
          <a href="#services" className="text-white text-4xl cursor-pointer">
            <i className="fas fa-chevron-down"></i>
          </a>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-gray-50 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-50/80 z-10"></div>
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('')",
            backgroundAttachment: isMobile ? 'scroll' : 'fixed',
            zIndex: 1,
          }}
        ></div>

        <div className="container mx-auto px-4 relative z-20">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Premium Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We offer comprehensive car care solutions using the latest technology and premium products
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative z-20">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                <div className="h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <i className={`fas ${service.icon} text-blue-500 text-2xl mr-3`}></i>
                    <h3 className="text-2xl font-bold text-gray-800">{service.title}</h3>
                  </div>
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  <div className="flex justify-between items-center">
                    <span className="text-xl font-bold text-blue-600">{ }</span>
                    <button
                      onClick={() => handleWhatsAppClick(service.title)}
                      className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg flex items-center transition-all"
                    >
                      <i className="fab fa-whatsapp mr-2"></i>
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <div className="fixed bottom-6 right-6 z-50 animate-bounce-slow">
        <button
          onClick={() => handleWhatsAppClick()}
          className="bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all transform hover:scale-110"
        >
          <i className="fab fa-whatsapp text-3xl"></i>
        </button>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="text-2xl font-bold mb-6 flex items-center">
                <i className="fas fa-car-wash mr-2"></i>
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">
                  SHINE WITH STEAM®
                </span>
              </div>
              <p className="text-gray-400 mb-4">
                Premium car care services using advanced steam technology and eco-friendly solutions.
              </p>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/share/15mZ5bKA4x/?mibextid=wwXIfr" className="text-gray-400 hover:text-white transition-colors">
                  <i className="fab fa-facebook-f text-xl"></i>
                </a>
                <a href="https://www.instagram.com/shinewithsteam?igsh=MW1tNWphNXE3cWtyZg%3D%3D&utm_source=qr" className="text-gray-400 hover:text-white transition-colors">
                  <i className="fab fa-instagram text-xl"></i>
                </a>
                {/* <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <i className="fab fa-twitter text-xl"></i>
                </a> */}
                <a href="https://www.youtube.com/@shinewithsteam2359" className="text-gray-400 hover:text-white transition-colors">
                  <i className="fab fa-youtube text-xl"></i>
                </a>
              </div>
            </div>

            {/* <div>
              <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
              <ul className="space-y-3">
                <li><a href="#services" className="text-gray-400 hover:text-white transition-colors">Services</a></li>
                <li><a href="#pricing" className="text-gray-400 hover:text-white transition-colors">Pricing</a></li>
                <li><a href="#process" className="text-gray-400 hover:text-white transition-colors">Process</a></li>
                <li><a href="#accessories" className="text-gray-400 hover:text-white transition-colors">Accessories</a></li>
              </ul>
            </div> */}

            <div>
              <h3 className="text-lg font-semibold mb-6">Contact Info</h3>
              <ul className="space-y-3">
                <li className="flex items-center text-gray-400">
                  <i className="fas fa-map-marker-alt w-6"></i>
                  <span>Dharmapuri Colony, uppal, Hyderabad. 500039</span>
                </li>
                <li className="flex items-center text-gray-400">
                  <i className="fas fa-phone w-6"></i>
                  <span>+917386778999</span>
                </li>
                <li className="flex items-center text-gray-400">
                  <i className="fas fa-envelope w-6"></i>
                  <span>shinewithsteam1@gmail.com</span>
                </li>
                <li className="flex items-center text-gray-400">
                  <i className="fas fa-clock w-6"></i>
                  <span>Mon-Sat: 8:00 AM - 7:00 PM</span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-6">Payment Methods</h3>
              <div className="flex flex-wrap gap-4">
                <i className="fab fa-cc-visa text-3xl text-gray-400"></i>
                <i className="fab fa-cc-mastercard text-3xl text-gray-400"></i>
              </div>

              <div className="mt-6">
                <h3 className="text-lg font-semibold mb-4">Newsletter</h3>
                <div className="flex">
                  <input
                    type="email"
                    placeholder="Your email"
                    className="bg-gray-800 text-white px-4 py-2 rounded-l-lg focus:outline-none flex-1 text-sm"
                  />
                  <button className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-r-lg transition-colors">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
            <p>© {new Date().getFullYear()} SHINE WITH STEAM® All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;